import React from "react";
import PropTypes from "prop-types";
import { Segment, Item, Grid, Image, Icon } from "semantic-ui-react";
import { ItemData, Paginate } from "../../components";
import Link from "next/link";
import millify from "millify";
var humanFormat = require("human-format");
import { ButtonItem } from "../../components";
import { Iconstyle, IconstyleRed } from "./element";

const HomesList = ({
  itemData,
  href,
  prev,
  active,
  header,
  getData,
  customclass,
  save,
  heart,
  handleHover,
  handleUnhover,
  isnhmap,
  checkIfImageExistshome,
  isEnabled,
  ...props
}) => {
  let data = itemData.length;
  let page_size = isnhmap ? 6 : 3;
  let indexdata = (active - 1) * page_size;
  // if (itemData.hasOwnProperty('address')) {
  //   street = address.street;
  //   city = address.city;
  //   state = address.state;
  //   zip = address.zip;
  // }

  return (
    <div style={{ paddingLeft: 0 }}>
      {itemData.length !== 0 && (
        <Item.Group>
          {itemData
            .slice(indexdata)
            .slice(0, page_size)
            .map((item, index) => {
              let finaladd;
              let finaladdsec;
              let bathtotal;
              let price;
              let media;
              if (item.MlsStatus === "Sold") {
                if (Number.isInteger(item.ClosePrice)) {
                  price = "$" + humanFormat(item.ClosePrice).replace(/\s/g, "");
                } else {
                  price = item.ClosePrice;
                }
              } else {
                if (Number.isInteger(item.ListPrice)) {
                  price = "$" + humanFormat(item.ListPrice).replace(/\s/g, "");
                } else {
                  price = item.ListPrice;
                }
              }
              if (item.UnparsedAddress) {
                // let add = item.UnparsedAddress.split(",");

                // if (add.length > 3) {
                //   finaladd = add[2];
                //   finaladdsec = add[0] + ", " + add[1] + " " + add[3];
                // } else {
                //   finaladd = item.UnparsedAddress;
                //   finaladdsec = "";
                // }

                finaladd =
                  item.UnparsedAddress +
                  ", " +
                  item.City.replace(/([a-z])([A-Z])/g, "$1 $2") +
                  ", " +
                  item.StateOrProvince +
                  ", " +
                  item.PostalCode;
              }
              if (item.BathroomsHalf) {
                bathtotal = item.BathroomsFull + item.BathroomsHalf * 0.5;
              } else {
                bathtotal = item.BathroomsFull;
              }

              if (item.SourceId) {
                // if (checkIfImageExistshome(item.ThumbnailUrl)) {
                media = item.ThumbnailUrl;
                // } else if (
                //   checkIfImageExistshome(item.ThumbnailUrl) !== undefined
                // ) {
                //   media =
                //     process.env.NEXT_PUBLIC_CDN_ID + "static/images/homedefault.jpg";
                // }
              } else {
                if (item.Media && item.Media.length > 0) {
                  let url = item.Media[0].MediaURL;
                  let finaloutput = "";
                  //media = url;

                  //if (checkIfImageExistshome(url)) {
                  media = url;
                  // } else if (checkIfImageExistshome(url) !== undefined) {
                  //   media =
                  //     process.env.NEXT_PUBLIC_CDN_ID +
                  //     "static/images/homedefault.jpg";
                  // }

                  // imageExists(url, function (exists) {
                  //   if (exists) {
                  //     media = url;
                  //   } else {
                  //     media =
                  //       process.env.NEXT_PUBLIC_CDN_ID +
                  //       "static/images/homedefault.jpg";
                  //   }
                  // });
                } else {
                  media =
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/homedefault.jpg";
                }
              }

              return (
                <Item key={index}>
                  <div
                    className="ui fluid image"
                    style={{ height: "285px" }}
                    onMouseEnter={() => handleHover(item)}
                    onMouseLeave={() => handleUnhover(item)}
                  >
                    <Link
                      href={"/DetailsListing/?id=" + item.ListingKeyNumeric}
                      title={item.ListingKeyNumeric}
                      style={{ cursor: "pointer", height: "inherit" }}
                      target="_blank"
                    >
                      {/* <a
                        style={{ cursor: "pointer", height: "inherit" }}
                        target="_blank"
                      > */}
                      <img
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            process.env.NEXT_PUBLIC_CDN_ID +
                            "static/images/homedefault.jpg";
                        }}
                        src={media}
                        style={{ height: "inherit" }}
                        alt={finaladd}
                        title={finaladd}
                      />
                      {/* <Image style={{ height: "inherit" }} src={media} /> */}
                      {/* </a> */}
                    </Link>
                    <div
                      style={{
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        height: "auto",
                        color: "white",
                        // opacity: 0.6
                      }}
                      className="home_list_main"
                    >
                      <Link
                        href={"/DetailsListing/?id=" + item.ListingKeyNumeric}
                        title={item.ListingKeyNumeric}
                        target="_blank"
                        style={{ color: "#FFF" }}
                      >
                        {/* <a target="_blank" style={{ color: "#FFF" }}> */}
                        <Grid style={{ padding: "0px 10px" }}>
                          <Grid.Column width={9}>
                            <Grid.Row>
                              <span className="home_price_main">
                                <strong>{price}</strong>
                              </span>
                            </Grid.Row>
                            <Grid.Row>
                              {finaladd}
                              <br />
                              {finaladdsec}
                            </Grid.Row>
                            {/*<Grid.Row>{item.address.city}, {item.address.state} {item.address.zip}</Grid.Row>*/}
                          </Grid.Column>
                          <Grid.Column width={7}>
                            <Grid
                              divided
                              style={{ padding: 10, textAlign: "center" }}
                            >
                              <Grid.Column width={5}>
                                <Grid.Row>
                                  {item.BedroomsTotal
                                    ? item.BedroomsTotal
                                    : "-"}
                                </Grid.Row>
                                <Grid.Row>Beds</Grid.Row>
                              </Grid.Column>
                              <Grid.Column width={5}>
                                <Grid.Row>
                                  {bathtotal ? bathtotal : "-"}
                                </Grid.Row>
                                <Grid.Row>Baths</Grid.Row>
                              </Grid.Column>
                              <Grid.Column width={6}>
                                <Grid.Row>
                                  {item.LivingArea ? item.LivingArea : "-"}
                                </Grid.Row>
                                <Grid.Row>sq.ft.</Grid.Row>
                              </Grid.Column>
                            </Grid>
                          </Grid.Column>
                        </Grid>
                        {/* </a> */}
                      </Link>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        width: "100%",
                        height: "auto",
                      }}
                    >
                      <Grid style={{ padding: 10 }}>
                        <Grid.Column width={9}>
                          {/*<Grid.Row style={{backgroundColor: 'green', textAlign: 'center', color: 'white'}}>Open SUN 1PM to*/}
                          {/*4 PM</Grid.Row>*/}
                        </Grid.Column>
                        <Grid.Column floated="right">
                          <Grid.Row>
                            {heart && heart[item.ListingKeyNumeric] ? (
                              <span
                                onClick={(e) =>
                                  save(item.ListingKeyNumeric, item)
                                }
                              >
                                <Icon
                                  size="big"
                                  name="heart"
                                  //color="#c02e26"
                                  style={IconstyleRed}
                                />
                              </span>
                            ) : (
                              <span
                                onClick={(e) =>
                                  save(item.ListingKeyNumeric, item)
                                }
                              >
                                <Icon
                                  size="big"
                                  name="heart outline"
                                  style={Iconstyle}
                                />
                              </span>
                            )}
                          </Grid.Row>
                        </Grid.Column>
                      </Grid>
                    </div>
                  </div>
                </Item>
              );
            })}
        </Item.Group>
      )}
      {itemData.length !== 0 && (
        <Paginate
          length={itemData.length}
          prev={prev}
          active={active}
          isEnabled={isEnabled}
          {...props}
        />
      )}
    </div>
  );
};

HomesList.propTypes = {
  itemData: PropTypes.array.isRequired,
};

export default HomesList;
